// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { DomainWithRelationsSchema } from './DomainRelationsSchema'
import type { DomainWithRelations } from './DomainRelationsSchema'
import { HostWithRelationsSchema } from './HostRelationsSchema'
import type { HostWithRelations } from './HostRelationsSchema'
import { GatewayWithRelationsSchema } from './GatewayRelationsSchema'
import type { GatewayWithRelations } from './GatewayRelationsSchema'
import { NetworkServiceWithRelationsSchema } from './NetworkServiceRelationsSchema'
import type { NetworkServiceWithRelations } from './NetworkServiceRelationsSchema'
import { VhostBindingSchema } from './VhostBindingSchema';

/////////////////////////////////////////
// VHOST BINDING RELATION SCHEMA
/////////////////////////////////////////

export type VhostBindingRelations = {
  surface: ExternalNetworkWithRelations;
  domain: DomainWithRelations;
  host?: HostWithRelations | null;
  gateway?: GatewayWithRelations | null;
  networkService?: NetworkServiceWithRelations | null;
};

export type VhostBindingWithRelations = z.infer<typeof VhostBindingSchema> & VhostBindingRelations

export const VhostBindingWithRelationsSchema: z.ZodType<VhostBindingWithRelations> = VhostBindingSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  domain: z.lazy(() => DomainWithRelationsSchema),
  host: z.lazy(() => HostWithRelationsSchema).nullable(),
  gateway: z.lazy(() => GatewayWithRelationsSchema).nullable(),
  networkService: z.lazy(() => NetworkServiceWithRelationsSchema).nullable(),
}))